// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2lXtG","col":"styles_col__2s2qk"};